<template>
    <div>
        <model-selection-radio :characteristic="firstCharacteristic" :doorConfigurationProp="context" />
        <model-selection-radio :characteristic="secondCharacteristic" :doorConfigurationProp="context" />
    </div>
</template>
<script>
    import Vue from 'vue'; 
    import MSRadio from './MSRadio.vue';

    export default Vue.extend({
        name: 'MSRadioContainerDouble',        
        props: {
            firstCharacteristic: Object,
            secondCharacteristic: Object,
            settingsContent: Number,
            settingsVal: Number,
            context: Number
        },
        components: {
            'model-selection-radio': MSRadio,
        },
        data() {
            return {
                
            }
        },
        computed: { 

        },
        methods: {
             
        },    
    })
</script>